import axios from "axios";
import dayjs from "dayjs";
import dayjsTimezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
import { api } from "../helpers/apiHelper";
import { api as api3 } from "../helpers/apiHelperV3";
import { CompetitionAPIHelper } from "../helpers/competitionAPIHelper";

let source; // for cancelling current request when a new request is made eg when switching between live, popular and all tabs

export const getCompetitionList = (params): any => {
  const url = CompetitionAPIHelper.getCompetitionListUrl();

  // If there is a request processing then cancel it
  source && source.cancel("Operation canceled due to new request.");
  // save the new request for cancellation
  source = axios.CancelToken.source();
  //
  return api3
    .get(url, {
      params: params,
      cancelToken: source.token,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        throw error;
      }
    });
};

/**
 * fetch a single Competition
 */

/**
 * fetch a list of events for a single competition
 */
export const getSingleCompetitionList = (
  size: number,
  page: number,
  competitionId: any,
  searchResult?: boolean
): any => {
  // get url
  let url = CompetitionAPIHelper.getSingleCompetitionListUrl(competitionId);
  let params: {
    page: number;
    size: number;
    live?: boolean;
    nonLive?: boolean;
    after?: number;
    before?: number;
    orderBy?: string;
  } = {
    size: size,
    page: page,
  };
  // If there is a request processing then cancel it
  source && source.cancel("Operation canceled due to new request.");
  // save the new request for cancellation
  CompetitionAPIHelper.getSingleCompetitionListAsianViewParams(params);
  return api3
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        throw error;
      }
    });
};

/**
 * fetch a list of dates for one or more navigation node ids
 */
export const getDatesWithEvents = (nodeIds: number[] | string[]): any => {
  dayjs.extend(utc);
  dayjs.extend(dayjsTimezone);

  const url = CompetitionAPIHelper.getDatesWithEventsUrl();
  // calculate timezone offset in minutes
  const endOfDay = dayjs().endOf("day");
  // set timezone offset
  const timezoneOffset = dayjs.tz(endOfDay).utcOffset();

  // timezone offset to params
  let params = {
    navigationTreeNodeIds: nodeIds.join(","),
    timezoneoffset: timezoneOffset,
  };
  return api
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      if (axios.isCancel(error)) {
        console.log(error.message);
      } else {
        throw error;
      }
    });
};

/**
 * fetch the number of live events with a navigation node id,
 * If no nodeId is provided, the number of live events for all nodes will be returned
 */
export const getNumberOfLiveEvents = (nodeId?: number): any => {
  const url = CompetitionAPIHelper.getNumberOfLiveEventsUrl();

  const params = nodeId ? { navigationNodeId: nodeId } : {};

  return api3
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};

/**
 * fetch the number of future events with a navigation node id
 */
export const getNumberOfFutureEvents = (nodeIds: string | number[]): any => {
  const url = CompetitionAPIHelper.getNumberOfFutureEventsUrl();
  // nodeIds can be a number, a string, or an array
  // TODO: fix why different types are being used
  let selectedNode: number | null = null;
  if (typeof nodeIds === "number") {
    selectedNode = nodeIds;
  } else if (typeof nodeIds === "string" && nodeIds.length > 0) {
    const nodes = nodeIds.split(",");
    const lastNode = nodes[nodes.length - 1];
    selectedNode = !isNaN(parseInt(lastNode)) ? parseInt(lastNode) : null;
  } else if (Array.isArray(nodeIds) && nodeIds.length > 0) {
    const lastNode = nodeIds[nodeIds.length - 1];
    selectedNode = typeof lastNode === "number" ? lastNode : null;
  }
  const params = {
    navigationNodeId: selectedNode,
  };

  return api3
    .get(url, {
      params: params,
    })
    .then(resp => {
      return resp.data;
    })
    .catch(error => {
      throw error;
    });
};
